/**
 * Mirrors the backend `RetryActionType` (src/constants/retry/retry-config.constants.ts in
 * withpara/para-node). It has exactly ONE member today, which is why there is no action-type
 * filter in the UI and why the templates table holds a single row.
 */
export enum RetryActionType {
  RetryFailedPayment = 'retry_failed_payment',
}

/**
 * Mirrors the backend `RetryActionJobStatus`. Only `Scheduled` jobs may be rescheduled —
 * `AdminRetryManagementService.rescheduleOne` throws otherwise.
 */
export enum RetryActionJobStatus {
  Scheduled = 'scheduled',
  Processing = 'processing',
  Completed = 'completed',
}
